function reveal_gsap() {
	767 < $(window).width() ? $(".reveal-text").waypoint({
		handler: function () {
			var e = $(this.element);
			$(this.element).data("delay");
			e.hasClass("animated") || e.hasClass("anim-title") && !e.hasClass("animtitle-done") && (e.addClass("animtitle-done"), e.parentSplit = new SplitText(e, {
				type: "lines",
				linesClass: "split-parent"
			}), e.childSplit = new SplitText(e, {
				type: "words,chars",
				charsClass: "title-char"
			}), e.anim = gsap.from(e.childSplit.chars, {
				duration: .35,
				ease: Power3,
				rotate: 10,
				y: "200%",
				stagger: .04,
				delay: .2
			}))
		}, offset: function () {
			var e = $(this.element).data("offset") || 0;
			return Waypoint.viewportWidth() <= 480 ? Waypoint.viewportHeight() - 180 : Waypoint.viewportHeight() + e
		}
	}) : $(".reveal-text").each(function (e) {
		$(".reveal-text").addClass("animated")
	})
}

window.addEventListener("load", function(event) {
	if ($(".reveal-text").length > 0) {
		reveal_gsap();
	}
})